import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Paper, TextField, FormControl, Select,
  MenuItem, InputLabel, Button, Snackbar, Alert
} from '@mui/material';
import {api}from '../services/api';

const CreateTemplatePage = () => {
  const [templateName, setTemplateName] = useState('');
  const [selectedTemplateOption, setSelectedTemplateOption] = useState('');
  const [templateOptions, setTemplateOptions] = useState([]);
  const [resourceTemplates, setResourceTemplates] = useState([]);
  const [selectedResourceTemplate, setSelectedResourceTemplate] = useState('');
  const [goldenImages, setGoldenImages] = useState([]);
  const [selectedGoldenImage, setSelectedGoldenImage] = useState('');
  const [templatePrice, setTemplatePrice] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    const fetchTemplateOptions = async () => {
      try {
        const templateOptionsResponse = await api.get('/api/AzureResource/template-options', {
          headers: {
            'X-CORRELATION-ID': 'd113aeba-b7f7-4591-8646-73e5b466e819',
            'accept': 'text/plain'
          }
        });
        setTemplateOptions(templateOptionsResponse.data);
      } catch (error) {
        setSnackbarMessage('Error fetching template options');
        setSnackbarOpen(true);
      }
    };

    fetchTemplateOptions();
  }, []);

  const handleTemplateOptionChange = async (event) => {
    const selectedOptionId = event.target.value;
    setSelectedTemplateOption(selectedOptionId);

    if (selectedOptionId === 1) {
      // Fetch resource templates
      try {
        const resourceTemplatesResponse = await api.get('/api/AzureResource/services/124', {
          headers: {
            'X-CORRELATION-ID': '5323e2de-391b-4d5b-9a2c-d5d4b6a56487',
            'accept': 'text/plain'
          }
        });
        setResourceTemplates(resourceTemplatesResponse.data);
      } catch (error) {
        setSnackbarMessage('Error fetching resource templates');
        setSnackbarOpen(true);
      }
    } else if (selectedOptionId === 2) {
      // Fetch golden images
      try {
        const goldenImageResponse = await api.get('/api/AzureResource/golden-image-template-location/4/124', {
          headers: {
            'X-CORRELATION-ID': '5323e2de-391b-4d5b-9a2c-d5d4b6a56487',
            'accept': 'text/plain'
          }
        });
        setGoldenImages(goldenImageResponse.data);
      } catch (error) {
        setSnackbarMessage('Error fetching golden image options');
        setSnackbarOpen(true);
      }
    }
  };

  const fetchPrice = async (templateId) => {
    try {
      const priceResponse = await api.get(`/api/AzureResource/${templateId}-vmPrice`, {
        headers: {
          'X-CORRELATION-ID': '5323e2de-391b-4d5b-9a2c-d5d4b6a56487',
          'accept': 'text/plain'
        }
      });
      setTemplatePrice(priceResponse.data);
    } catch (error) {
      setSnackbarMessage('Error fetching template price');
      setSnackbarOpen(true);
    }
  };

  const handleResourceTemplateChange = (event) => {
    const templateId = event.target.value;
    setSelectedResourceTemplate(templateId);
    fetchPrice(templateId);
  };

  const handleGoldenImageChange = (event) => {
    const goldenImageId = event.target.value;
    setSelectedGoldenImage(goldenImageId);
    // For golden images, use the fixed template ID of 2
    fetchPrice(2);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" gutterBottom>Create Template</Typography>
        
        <TextField
          fullWidth
          label="Template Name"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          sx={{ mt: 2 }}
        />

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Template Options</InputLabel>
          <Select
            value={selectedTemplateOption}
            onChange={handleTemplateOptionChange}
          >
            {templateOptions.map((option) => (
              <MenuItem key={option.templateOptionId} value={option.templateOptionId}>
                {option.templateOptionName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedTemplateOption === '1' && resourceTemplates.length > 0 && (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Resource Templates</InputLabel>
            <Select
              value={selectedResourceTemplate}
              onChange={handleResourceTemplateChange}
            >
              {resourceTemplates.map((template) => (
                <MenuItem key={template.template_Id} value={template.template_Id}>
                  {template.templateName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {selectedTemplateOption === '2' && goldenImages.length > 0 && (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Golden Images</InputLabel>
            <Select
              value={selectedGoldenImage}
              onChange={handleGoldenImageChange}
            >
              {goldenImages.map((image) => (
                <MenuItem key={image.goldenImageId} value={image.goldenImageId}>
                  {image.goldenImageName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <Typography variant="body1" sx={{ mt: 2 }}>
          Price: {templatePrice ? `$${templatePrice}` : '0'}
        </Typography>

        <Box sx={{ display: 'flex', mt: 2, justifyContent: 'space-between' }}>
          
          <Button variant="cancelContained" 
          // color="secondary"
          >Cancel</Button>
          <Button variant="contained"
           color="primary"
           >Submit</Button>
        </Box>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
          <Alert onClose={() => setSnackbarOpen(false)} severity="error">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Paper>
    </Box>
  );
};

export default CreateTemplatePage;
